import React, { useEffect, useMemo, useState } from "react";
import NavbarStandard from "../navbar/NavbarStandard";
import { Col, Row } from "reactstrap";
import CustomLogo from "../../assets/img/illustrations/new-sikka-logo.png";
import publicIp from "react-public-ip";
import Loader from "../common/Loader";
import { useLocation } from "react-router";
import AuthService from "../../services/authenticationService";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
const hostName = (url) => {
  if (url.includes("localhost")) {
    return "localhost";
  } else if (url.includes("qa")) {
    return "qa";
  } else {
    return "prod";
  }
};
const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const Sikkaapillm = () => {
  const [loading, setLoading] = useState(true);
  const [ip, setIp] = useState(null);
  useMemo(() => {
    async function getIPAddress() {
      let tempIp = await publicIp.v4();
      if (tempIp) {
        setLoading(false);
        setIp(tempIp);
      }
    }
    getIPAddress();
  }, []);
  const query = useQuery();
  var from_where = "other";
  if (query.get("ref")) {
    from_where = query.get("ref")
  }
  useEffect(() => {
    if (ip) {
      const body = {
        from_where: from_where,
        ip_address: ip,
        host_name: hostName(window.location.href),
      };
      AuthService.llmTrackingCall(body).then(
        () => { },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        
        }
      );
    }
  }, [ip])
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div id="sikka-llm-page">
          <NavbarStandard isMenuShow={false} customLogo={CustomLogo} />

          <div className="heading">
            <h1>
            15+ years of Synthetic Dental Data for your LLM Training/fine tuning
            </h1>
            {/* <p>15 years of opt-in de-identified</p> */}
          </div>

          <p>
            In the ever-evolving landscape of healthcare innovation, the
            availability of synthetic dental data based on over 15 years of
            opt-in de-identified data from more than 30,000 dental offices opens
            up exciting possibilities for advancing artificial intelligence (AI)
            technologies, particularly Language Model (LLM) training. This
            extensive dataset, meticulously de-identified to protect patient
            privacy, encapsulates a wealth of longitudinal patient records,
            treatment histories ,outcomes, diagnostic insights and evolving
            trends within the dental industry, a robust foundation for
            developing and refining AI-driven solutions that can transform oral
            healthcare and patient outcomes.
          </p>

          <h3>The Value of Synthetic Dental Data</h3>
          <p>
            Synthetic dental data derived from a diverse network of over 30,000
            dental offices offers a comprehensive representation of patient
            interactions, disease progression, clinical encounters, treatment
            modalities, and patient demographics over an extended period. This
            curated dataset, de-identified for privacy compliance, maintains the
            richness and complexity of real-world scenarios. It enables the
            development of AI models to identify patterns, trends, and
            correlations, empowering personalized treatment strategies and
            predictive analytics. Key benefits include:
            <ul className="llm-li">
              <li>
                Disease Modeling: Historical data facilitates the creation of
                disease progression models, allowing for early detection and
                intervention strategies tailored to individual patient profiles.
              </li>
              <li>
                Risk Assessment: AI algorithms trained on this dataset can
                assess patient risk factors, predict oral health complications,
                and recommend preventive measures to improve overall patient
                outcomes.
              </li>
              <li>
                Patient-Provider Communication: Develop chatbots or virtual
                assistants capable of answering patient queries and providing
                personalized oral health advice based on historical data.
              </li>
              <li>
                Information Retrieval: Build dental-specific search engines that
                retrieve relevant literature, guidelines, and case studies to
                support evidence-based practice.
              </li>
            </ul>
          </p>

          <p>
            <b>Data Exploration and Feature Engineering :</b> Dive deep into our
            dataset to identify relevant features and textual patterns that can
            enhance LLM performance in dental contexts.
          </p>
          <h3>How to Access and Utilize the Dental Dataset</h3>

          <p>
            Accessing our extensive dental dataset for LLM training is designed
            to be straightforward and collaborative:
            <br />
            Data Access Request: Contact us to request access to our anonymized
            and securely stored dental dataset, tailored specifically for AI
            model training.
            <br />
            Dataset can be delivered via{" "}
            <span className="sikka-llm-link">
              <a href={"https://sikka.ai/oneapi"} target="_">
                Sikka API
              </a>
            </span>{" "}
            in JSON or CSV format.
          </p>

          <h4>
            Conclusion{": "} Empowering Dental Innovation with AI-Driven
            Insights
          </h4>
          <p>
            <b>In conclusion</b>, synthetic dental data derived from over 15
            years of opt-in de-identified data across more than 30,000 dental
            offices represents a transformative asset for AI-driven innovation
            in dentistry. By harnessing the power of LLMs and leveraging
            synthetic data for training, stakeholders in the dental industry can
            unlock novel applications that enhance patient care, streamline
            workflows, and drive precision dentistry forward. We invite
            researchers, developers, and dental professionals to collaborate
            with us in utilizing this invaluable resource to advance the
            frontiers of AI-driven dental healthcare and improve oral health
            outcomes. Contact us today to explore how you can utilize our
            extensive dental dataset for LLM training and contribute to shaping
            the future of dental AI technologies.{" "}
          </p>
          <br />
          {/* <p className="text-center">
            Contact us at{""}
            <span className="sikka-llm-link">
              <a href={"https://sikka.ai/request-quote"} target="_">
                Sikka ONE API
              </a>
            </span>{" "}
          </p> */}
          <p className="text-center">
                        <Button
                            variant="falcon-primary"
                            style={{ paddingTop: "3px", paddingBottom: "3px" }}
                            size="sm"
                            onClick={() => {
                                window.location.assign(`${process.env.PUBLIC_URL}/authentication/register?ref=Synthetic Dental Data`);
                            }}
                        >
                            Join our waitlist
                        </Button>
                    </p>
        </div>
        
      )}
    </>
  );
};

export default Sikkaapillm;
